import './component.scss'
import 'PackWerkNurikaeSite/pages/home/index/partials/top_advice/card/component'
import '@splidejs/splide/css';
import { Splide } from '@splidejs/splide';

const PC_PER_PAGE = 3;

const SLIDER_CONFIGS = {
  'top-advice-pc': {
    speed: 800,
    perPage: PC_PER_PAGE,
    perMove: PC_PER_PAGE,
    gap: '8px',
    pagination: false,
  },
  'top-advice-sp': {
    speed: 800,
    perMove: 1,
    gap: '12px',
    padding: '30px',
    pagination: false,
    focus: 'center',
  }
};

// スライダー初期化関数
function initializeSlider (id, config) {
  const element = document.getElementById(id);
  if (!element) return null;

  const splide = new Splide(`#${id}`, config);
  splide.mount();
}

// アドバイス展開機能
function initializeAdviceToggle() {
  const moreButtons = document.querySelectorAll('.js-top-advice-card__more-button');
  
  moreButtons.forEach(button => {
    const advice = button.closest('.top-advice-card__advice-container').querySelector('.js-top-advice-card__advice');
    
    // 5行以下の場合は「もっと見る」ボタンを非表示にする
    const adviceHeight = advice.scrollHeight;
    const displayHeight = advice.offsetHeight;
    
    if (adviceHeight <= displayHeight) {
      button.classList.add('hidden');
      return;
    }
    
    // ボタンをクリックした時はカードのリンク先に遷移する
    button.addEventListener('click', function(e) {
      e.stopPropagation();
      window.location.href = button.closest('.top-advice-card').href;
    });
  });
}

window.addEventListener('load', function () {
  Object.entries(SLIDER_CONFIGS).forEach(([id, config]) => { initializeSlider(id, config); });
  
  // アドバイス展開機能を初期化
  initializeAdviceToggle();
});
